'use client'
import {
  useConfig_default
} from "./chunk-UGF34K5Q.mjs";

// src/hooks/useRouter.ts
var useRouter = () => {
  const config = useConfig_default();
  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const search = new URLSearchParams(typeof window !== "undefined" ? window.location.search : {});
  return {
    locale: config.router.locale,
    languages: config.i18n.languages,
    dir: config.router.dir,
    pathname: config.router.pathname || pathname,
    push: config.router.push,
    replace: config.router.replace,
    search: config.router.search || search,
    setSearch: config.router.setSearch,
    baseUrl: config.router.baseUrl,
    setLocale: config.router.setLocale,
    params: config.router.params
  };
};

export {
  useRouter
};
//# sourceMappingURL=chunk-UGTHHAHH.mjs.map